import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import './EditSubjectDetails.module.scss';
import Select from 'react-select';
import { colourStyles } from 'utilities/colored-select-circle.js';
import nlDateString from 'utilities/nl-date-string';
import Modal from 'react-responsive-modal';
import MoveSubject from 'components/UI/Popup/MoveSubject/MoveSubject';

/**
 * Import components
 */
import DropDown from 'components/UI/DropDown/DropDown';
import { Creator, Selector } from 'components/UI/Selectables/Selectables';
import Subject from 'components/UI/Subject/Subject';
import Checkbox from 'components/UI/Checkbox/Checkbox';
import Tip from 'components/UI/Tip/Tip';
import InputHomeworkForm from 'components/UI/Popup/InputHomework/components/InputHomeworkForm';

/**
 * Import FontAwesome
 */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

/**
 * Import actions
 */
import updateEvent from 'actions/event/update';
import {
    homeworkReset,
} from 'actions/new-homework';

const mapStateToProps = (state, props) => {
    return {
        user: state.authentication.user
    };
};

const mapDispatchToProps = {
    updateEvent,
    homeworkReset
};

const customStyles = {
    control: styles => ({ 
        ...styles, 
        fontSize: '12px',
    }),
    option: styles => ({
        ...styles,
        fontSize: '12px',
    })
};

const recurrenceTypes = [
    {
        value: '',
        label: 'Geen'
    },
    {
        value: 'weekly',
        label: 'Elke week'
    },
    {
        value: 'biweekly',
        label: 'Elke 2 weken'
    },
    {
        value: 'monthly',
        label: 'Elke 4 weken'
    },
];

let durationValues = [
    {
        value: 1,
        label: '1'
    },
    {
        value: 2,
        label: '2'
    },
    {
        value: 3,
        label: '3'
    },
    {
        value: 4,
        label: '4'
    },
    {
        value: 5,
        label: '5'
    },
    {
        value: 6,
        label: '6'
    },
    {
        value: 7,
        label: '7'
    },
    {
        value: 8,
        label: '8'
    },
    {
        value: 9,
        label: '9'
    },
    {
        value: 10,
        label: '10'
    },
];

const valueFromLabel = (opts, label) => opts.find(o => o.label === label);
const valueFromValue = (opts, value) => opts.find(o => o.value === value);

class InputHomework extends Component {

    constructor() {
        super();

        this.state = {
            event: {}
        };

        this.handleClose                        = this.handleClose.bind(this);
        this.handleRecurranceChange             = this.handleRecurranceChange.bind(this);
        this.updateEvent                        = this.updateEvent.bind(this);
        this.limitDuration                      = this.limitDuration.bind(this);
        this.handleRoomChange                   = this.handleRoomChange.bind(this);
        this.handleDurationChange               = this.handleDurationChange.bind(this);
        this.updateEventWithChosenEditMode      = this.updateEventWithChosenEditMode.bind(this);
    }

    componentDidMount() {

        let recurrence = '';
        let event = this.props.event;

        if (event.isRecurring == false) {
            recurrence = '';
        } else if (event.isRecurring && event.recurrencePattern.includes('WEEKLY') && event.recurrencePattern.includes('INTERVAL=1')) {
            recurrence = 'weekly';
        } else if (event.isRecurring && event.recurrencePattern.includes('WEEKLY') && event.recurrencePattern.includes('INTERVAL=2')) {
            recurrence = 'biweekly';
        } else if (event.isRecurring && event.recurrencePattern.includes('WEEKLY') && event.recurrencePattern.includes('INTERVAL=4')) {
            recurrence = 'monthly';
        }

        this.setState({
            event: {
                ...this.props.event,
                recurrence: recurrence,
                oldRecurrence: recurrence,
                showSubjectMovedPopup: false
            }
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.event && prevProps.event.id != this.props.event.id) {

        }
    }

    handleClose(event) {
        this.props.handleClose();
    }


    handleRecurranceChange(recurrence) {
        this.setState({ event: {
            ...this.state.event,
            recurrence: recurrence.value
        }});
    }

    handleRoomChange(event) {
        this.setState({ event: {
            ...this.state.event,
            room: event.target.value
        }});
    }

    handleDurationChange(duration) {
        this.setState({ event: {
            ...this.state.event,
            duration: duration.value
        }});
    }

    updateEventWithChosenEditMode(editMode) {
        let event = this.state.event;

        this.props.updateEvent({
            id: event.id,
            redit: editMode,
            origid: event.origid,
            startDateUtc: event.startDateUtc,
            endDateUtc: event.startDateUtc,
            ristart: event.startDateUtc,
            recurrence: event.recurrence,
            duration: event.duration,
            room: event.room,
            timeslot: event.timeslot,
            user_subject_id: event.user_subject_id,
            recurrencePattern: event.recurrencePattern,
            isRecurring: 1
        }).then((result) => {
            this.props.homeworkReset();
            this.props.onClose();
        });
    }

    updateEvent() {
        let event = this.state.event;

        if (this.props.event.isRecurring && event.recurrence == event.oldRecurrence && (event.duration != this.props.event.duration || event.room != this.props.event.room)) {
            this.setState({
                showSubjectMovedPopup: true
            });
            return;
        }

        if (!this.props.event.isRecurring) {
            //the old event was non-recurring, so just update the event
            this.props.updateEvent({
                id: event.id,
                recurrence: event.recurrence,
                duration: event.duration,
                room: event.room,
                recurrencePattern: event.recurrence != '' ? event.recurrence : null
            }).then((result) => {
                this.props.homeworkReset();
                this.props.onClose();
            });

        } else {
            //old event was recurring, change it
            let recurrencePattern = null;

            switch (event.recurrence) {
                case '':
                    break;
                case 'weekly':
                    recurrencePattern = 'FREQ=WEEKLY;INTERVAL=1';
                    break;
                case 'biweekly':
                    recurrencePattern = 'FREQ=WEEKLY;INTERVAL=2';
                    break;
                case 'monthly':
                    recurrencePattern = 'FREQ=WEEKLY;INTERVAL=4';
                    break;

            }

            this.props.updateEvent({
                id: event.id,
                redit: 'future',
                origid: event.origid,
                startDateUtc: event.startDateUtc,
                ristart: event.startDateUtc,
                recurrence: event.recurrence,
                duration: event.duration,
                room: event.room,
                timeslot: event.timeslot,
                user_subject_id: event.user_subject_id,
                recurrencePattern: recurrencePattern,
                isRecurring: recurrencePattern != null
            }).then((result) => {
                this.props.homeworkReset();
                this.props.onClose();
            });
        }
    }

    limitDuration() {
        let selectedHour = this.props.event.timeslot;

        let durations = [
            ...durationValues
        ];
        durations.length = (this.props.user.amount_of_cards + 1) - selectedHour;
        return durations;
    }

    render() {
        let limitedDuration = this.limitDuration();

        return (
            <Fragment>
                <div styleName="input-content">
                    <div styleName='top-bar'>
                        <h1 styleName="title">Uur instellingen</h1>
                    </div>
                    <div styleName='card-content'>
                        <div styleName='subject-details-wrapper'>
                            <div styleName="recurrence">
                                <p>Herhaling</p>
                                <Select onChange={this.handleRecurranceChange}
                                    value={valueFromValue(recurrenceTypes, this.state.event && this.state.event.recurrence)}
                                    isSearchable={false}
                                    options={recurrenceTypes}
                                    styles={customStyles}
                                    components={{
                                        IndicatorSeparator: () => null
                                    }}
                                />
                            </div>            
                    
                            <div styleName="hours">
                                <p>Lesuren</p>
                                <Select onChange={this.handleDurationChange}
                                    value={valueFromLabel(limitedDuration, this.state.event && `${this.state.event.duration}`)}
                                    options={limitedDuration}
                                    isSearchable={false}
                                    styles={customStyles}
                                    placeholder={''}
                                    components={{
                                        IndicatorSeparator: () => null
                                    }}
                                />
                            </div>

                            <div styleName="room">
                                <p>Lokaal</p>
                                <input value={this.state.event.room} onChange={this.handleRoomChange} maxLength='8'/>
                            </div>
                        </div>
                   
                        <div styleName='buttons'>
                            <p onClick={this.props.onClose}>Annuleer</p>
                            <p styleName='save' onClick={this.updateEvent}>{'Bijwerken'}</p>
                        </div>
                    </div>
                </div>
                <Modal open={this.state.showSubjectMovedPopup} onClose={this.closeSubjectMovedPopup} center styles={{
                    modal: {
                        borderRadius: '6px',
                        width: '500px',
                        height: '110px',
                        padding: '10px 15px'
                    },
                    closeIcon: {
                        display: 'none'
                    }
                }}>
                    <MoveSubject changeInsteadOfMove moveSubject={this.updateEventWithChosenEditMode} onClose={this.closeSubjectMovedPopup}/>
                </Modal>
            </Fragment>


            
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(InputHomework);
